import { Box } from '@mui/material';

/**
 * Placeholder for missing/empty data: an em dash dimmed to `text.disabled`. Renders as an inline
 * span so it inherits the surrounding Typography's font (size/weight) and only overrides the color.
 * Use this instead of a bare `'—'` so empty values read softer than real ones across the app.
 */
export const EmptyDash = () => (
  <Box component="span" sx={{ color: 'text.disabled' }}>
    —
  </Box>
);
